import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import MsgNetLoading from '../components/MsgNetLoading';
import ResultadoListTodos from '../components/ResultadoListTodos';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';
import CONFIG from '../config';
import { applyDelta, enrichResultados } from '../utils/wsDelta';

class TodosScreenClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            evento: null,
            competicion: null,
            sectores: [],
            controles: [],
            resultados: [],
            showSharePanel: false,
        };
        this.ws = null;
        this.wsReconnectTimer = null;
    }

    toogleSharePanel() {
        this.setState({ showSharePanel: !this.state.showSharePanel });
    }

    parseMsToMoment(fechaYYYYMMDD, ms) {
        const base = moment(fechaYYYYMMDD, 'YYYY-MM-DD');
        if (!base.isValid()) return null;
        const n = Number(ms);
        return Number.isFinite(n) ? base.startOf('day').add(n, 'ms') : base;
    }

    getEstadoCarrera() {
        const { competicion } = this.state;
        if (!competicion) return null;
        const fechaInicio = competicion.fecha_inicio
            ? this.parseMsToMoment(competicion.fecha_inicio, competicion.hora_inicio ?? 0)
            : null;
        const fechaFin = competicion.fecha_inicio
            ? (competicion.hora_fin != null
                ? this.parseMsToMoment(competicion.fecha_inicio, competicion.hora_fin)
                : (fechaInicio ? moment(fechaInicio).endOf('day') : null))
            : null;
        const ahora = moment();
        const haEmpezado = fechaInicio ? ahora.isAfter(fechaInicio) : false;
        
        const haFinalizado = Boolean(competicion.carrera_finalizada);
        return { haEmpezado, haFinalizado };
    }

    componentDidMount() {
        const competicionId = parseInt(this.props.params.competicionId, 10);
        this.fetchInitData(competicionId);
        this.connectWS(competicionId);
    }

    fetchInitData(competicionId) {
        fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/init/`)
            .then(r => r.json())
            .then(data => {
                this.setState({
                    competicion: data.competicion,
                    evento: data.evento,
                    sectores: data.sectores,
                    controles: data.controles,
                });
            })
            .catch(err => console.error('live-init error:', err));
    }

    refreshCompeticion(competicionId) {
        fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/init/`)
            .then(r => r.json())
            .then(data => {
                this.setState({ competicion: data.competicion });
            })
            .catch(() => {});
    }

    connectWS(competicionId) {
        if (this.ws) this.ws.close();
        this.ws = new WebSocket(`${CONFIG.WS_URL}/ws/${competicionId}`);
        this.ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.tipo === 'update') {
                const ctrl = data.controles || [];
                const resultados = (data.resultados || []).map(r => ({ ...r, ...r.controles }));
                this.setState({ controles: ctrl, resultados: enrichResultados(resultados, ctrl) });
                this.refreshCompeticion(competicionId);
            } else if (data.tipo === 'delta') {
                this.setState(prev => {
                    const ctrl = data.controles || prev.controles;
                    const resultados = applyDelta(prev.resultados, data.resultados || [], data.eliminados || []);
                    return { controles: ctrl, resultados: enrichResultados(resultados, ctrl) };
                });
            }
        };
        this.ws.onclose = () => {
            this.wsReconnectTimer = setTimeout(() => this.connectWS(competicionId), 3000);
        };
    }

    componentWillUnmount() {
        if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
        if (this.ws) this.ws.close();
    }

    onClickBack() {
        this.props.navigate(`/${this.state.competicion.evento_id}`);
    }

    render() {
        const { evento, competicion, resultados, controles, sectores, showSharePanel } = this.state;

        if (!competicion) {
            return (
                <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
                    <MsgNetLoading />
                </div>
            );
        }

        const estadoCarrera = this.getEstadoCarrera();
        let mensajeBanner = '';
        let claseBanner = 'ring-blue-500 text-white';
        if (estadoCarrera) {
            if (estadoCarrera.haFinalizado) {
                mensajeBanner = 'CARRERA FINALIZADA - Clasificación final';
                claseBanner = 'ring-slate-700 text-slate-300';
            } else if (estadoCarrera.haEmpezado) {
                mensajeBanner = 'CARRERA EN CURSO - Clasificación provisional basada en previsiones de llegada';
                claseBanner = 'ring-green-700 slate-300';
            } else {
                mensajeBanner = 'Listado de inscritos';
                claseBanner = 'ring-slate-700 text-slate-300';
            }
        }

        return (
            <div className="min-h-screen bg-gray-900 text-slate-100">
                <TopHeaderMenu
                    onClickBack={this.onClickBack.bind(this)}
                    onClickShare={this.toogleSharePanel.bind(this)}
                    competicion={competicion}
                    evento={evento}
                />
                <CompeticionHeaderMenu competicion={competicion} selected={6} evento={evento} />
                {competicion.visible && (
                    <div className="mx-auto max-w-5xl md:px-12 mt-0 pt-28">
                        <div className="flex justify-center">
                            <div className={['w-fit rounded-lg px-4 py-2 mb-4 mx-4 text-sm font-light tracking-wide text-center ring-1 font-montserrat', claseBanner].join(' ')}>
                                {mensajeBanner}
                            </div>
                        </div>
                        <div>
                            {resultados.length > 0 ? (
                                <ResultadoListTodos
                                    resultados={resultados}
                                    competicion={competicion}
                                    controles={controles}
                                    sectores={sectores}
                                />
                            ) : (
                                <div className="text-center py-8 text-gray-400">Cargando inscritos...</div>
                            )}
                        </div>
                    </div>
                )}
                {showSharePanel && (
                    <SharePanel
                        close={this.toogleSharePanel.bind(this)}
                        url={`/competicion/${competicion.id}/todos`}
                        title={`Todos los atletas en ${competicion.nombre} en ${evento ? evento.nombre : ''}`}
                    />
                )}
            </div>
        );
    }
}

function TodosScreen() {
    const navigate = useNavigate();
    const params = useParams();
    return <TodosScreenClass navigate={navigate} params={params} />;
}

export default TodosScreen;
